module.exports = __webpack_public_path__ + "img/bg-trailer.2810dab4.jpg";